/**
 * indexUsing
 * Mimics the way indexOf works, returning the index of an array where a callback returns true,
 * eagerly stops execution afterwards. Returns -1 if nothing is found.
 *
 * @param items list of items sorted in such a way that it reflects what you're looking to index
 * @param check function, takes a parameter and returns a boolean if it matches the parameters, accepts an item of items and current index as a second parameter
 * @returns index where check returned true, -1 if not found
 */
const indexUsing = <T>(
  items: T[],
  check: (item: T, i?: number) => boolean
): number => {
  if (items.length === 0) return -1;

  for (let i = 0; i <= items.length; i++) {
    if (check(items[i], i)) {
      return i;
    }
  }
  return -1;
};

export default indexUsing;
